import { render, staticRenderFns } from "./ExclusivePhone.vue?vue&type=template&id=56a135c4&"
import script from "./ExclusivePhone.vue?vue&type=script&lang=js&"
export * from "./ExclusivePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports